module.exports = __webpack_public_path__ + "img/65fr.687cf44b.png";